<template>
  <div class="main-body">
    <div class="header">余额不足报警</div>
    <div class="out">

      <div class="search2">

        <el-button type="success" size="mini" v-if="status==0" icon="el-icon-document-checked" @click="batchDeal">批量处理</el-button>

        <div style="float:right">

          <el-select v-model="status" placeholder="选择状态" style="margin-right: 10px;width:120px;">
              <el-option
                      v-for="item in status_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th"
                @selection-change="handleSelectionChange" border>

        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column prop="elderlyName" label="老人"></el-table-column>
        <el-table-column prop="nowBalance" label="当前余额"></el-table-column>
        <el-table-column label="处理状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">未处理</span>
            <span v-if="scope.row.status==1">已处理</span>
          </template>
        </el-table-column>
        <el-table-column prop="dealMessage" label="处理结果"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="提醒时间"></el-table-column>
        <el-table-column prop="dealTime" :formatter="timefilter" label="处理时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==0" type="primary" size="mini" @click="handleStatus(scope.row)">处理</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Deal ref="myDeal" v-show="showModalDeal" v-on:closeDeal="closeDeal" v-on:getList="getList"></Deal>

  </div>
</template>

<script>

import Deal from './Deal';

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "Page",
  data(){
    return{

      tableLoading:false,

      showModalDeal:false,
      showModalEdit:false,

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


      startEndTime:[],

      status_arr: [{
          value: 0,
          label: '未处理'
      }, {
          value: 1,
          label: '已处理'
      }],
      status: 0,



      multipleSelection:[],
      alarmRecordCodeArr:[],


    }
  },
  components:{
    Deal
  },
  created(){

    this.getList(false);
    this.th = this.$store.state.tableHeight;

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    batchDeal() {

      var list = this.multipleSelection

      if(this.multipleSelection.length < 1) {
        this.$message({type: 'warning', message: '请选择记录'});
        return;
      }
      else {
        for(var i in list) {
          list[i] = list[i].lessBalanceCode;
        }
      }

      //console.log(list);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"LessBalance/EditMul",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          status:1,
          lessBalanceCodes:list,
          dealMessage:'已处理',
          staffCode:getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        //this.tableLoading=false

        if(response.data.error == 0){

          this.getList();

        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        //this.tableLoading=false
        console.log(error);
      });


    },


    closeDeal(){
      this.showModalDeal = false;
    },
    handleStatus(row){
      this.showModalDeal = true;
      this.$refs.myDeal.init(row.lessBalanceCode,row.elderlyName);
    },

    timefilter(row,index,column){
      return timefilters(column)
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"LessBalance/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          status:this.status,
        }
      }).then( (response)=> {
        //console.log(response);
        this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        this.tableLoading=false
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

.main-body{
  background-color: #f2f2f2;height: 100%;
}

.main-body .header{
  background-color: #fff;padding:0px 10px; line-height: 50px;border-bottom: 1px solid #ddd;
}

.main-body .out {
  padding: 10px;
}

.main-body .out .search{

}

.main-body .out .table {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.main-body .out .page {
  background-color: #fff;padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

</style>
